import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat';


dayjs.extend(customParseFormat);

export class DateTimeFormatter {

    private static readonly supportedDateParseFormats = ["D.M.YYYY", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ssZ", "YYYY-MM-DDTHH:mm:ss.SSSZ"];
    private static readonly isoDateTimeFormat = "YYYY-MM-DDTHH:mm:ssZ";


    static formatAsFullYear(date: Date | undefined | null) {
        if (date === undefined || date === null) {
            return '';
        }
        return date.getFullYear().toString();
    }

    static formatDate(date: Date | string | null | undefined): string | null {
        if (!date) {
            return null;
        }
        return dayjs(date).format("L");
    }

    static formatDateTime(date: Date | string | null | undefined) {
        if (!date) {
            return null;
        }
        return dayjs(date).format("L LTS");
    }

    static formatAsIsoDateTime(date: string | null | undefined) {
        if (!date) {
            return undefined;
        }
        dayjs.extend(customParseFormat);
        return dayjs(date, this.supportedDateParseFormats, false).format(this.isoDateTimeFormat);
    }

    static formatAsIsoDateTimeAtEndOfDay(date: string | null | undefined) {
        if (!date) {
            return undefined;
        }
        dayjs.extend(customParseFormat);
        return dayjs(date, this.supportedDateParseFormats, false).endOf("day").format(this.isoDateTimeFormat);
    }

    static convertToEndOfDay(date: Date | null | undefined) {
        if (!date) {
            return undefined;
        }
        return dayjs(date).endOf("day").toDate() ;
    }

    static convertFromIsoDateTimeString(date: string | null | undefined) {
        if (!date) {
            return undefined;
        }

        dayjs.extend(customParseFormat);
        return dayjs(date).toDate();
    }

    static convertDateToIsoFormat(date: Date | null | undefined): string | undefined{
        if (!date) {
            return undefined;
        }
        return dayjs(date).format(this.isoDateTimeFormat);
    }
}
